import { render } from "./UserContractsComponent.vue?vue&type=template&id=66aecfbb&scoped=true"
import script from "./UserContractsComponent.vue?vue&type=script&lang=js"
export * from "./UserContractsComponent.vue?vue&type=script&lang=js"

import "./UserContractsComponent.vue?vue&type=style&index=0&id=66aecfbb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66aecfbb"]])

export default __exports__